import React, { Component } from "react";

export default class Login extends Component {
  state = {
    email: "",
    password: ""
  };
  handleLogin = e => {
    e.preventDefault();
    this.props.onLogin(this.state.email, this.state.password);
  };
  render() {
    return (
      <form className="container d-flex flex-column form--login" name="login" onSubmit={this.handleLogin}>
      <span className="icon-MadebyMade-Vector-LineIcons-Cafe-Outlined-07 text-center"></span>
      <h1 className="text-center">Please Login to Edit/Delete</h1>
        <div class="form-group form--input-group my-3">
          <label class="mb-0" htmlFor="email">Email:</label>
          <input
            className="form-control form-control-lg form--text-input"
            type="email"
            onChange={e => this.setState({ email: e.target.value })}
            required
          />
        </div>
        <div class="form-group form--input-group my-3">
          <label class="mb-0" htmlFor="password">Password:</label>
          <input
            className="form-control form-control-lg form--text-input"
            type="password"
            onChange={e => this.setState({ password: e.target.value })}
            required
          />
        </div>
        <div>
        {
            //disable login button if either email or password are blank
        }
          <button className="btn--primary w-100 mt-4"
            type="submit"
            disabled={!this.state.email || !this.state.password}
          >
            Login
            <span className="ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-in"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg></span>
          </button>
        </div>
      </form>
    );
  }
}
